import cs from 'classnames';
import BaseCell from '@tcs/client-portal-common/components/molecules/Table/cells/BaseCell';
import { useStyles } from '@tcs/client-portal-common/components/molecules/Table/style';
import formatCurrency from '@tcs/common/utils/formatCurrency';
import { Unicode } from '@tcs/common/utils/unicode';
interface CellProps {
  value: number;
}

const DebitCreditCell = ({ value }: CellProps) => {
  const classes = useStyles({});

  const formatContent = () => {
    if (value == null) return Unicode.EmDash;
    const content = formatCurrency(value);
    return value > 0 ? `+${content}` : content;
  };

  return (
    <BaseCell
      value={formatContent()}
      isPrivate
      align="left"
      className={cs(classes.alignNumbers, {
        [classes.debit]: value && value < 0,
      })}
    />
  );
};

export default DebitCreditCell;
